const e = "Düzenlemek için Enter'a basın", t = {
  pressEnterToEdit: e
};
export {
  t as default,
  e as pressEnterToEdit
};
